export default vm => [
  {
    key: 'companyName',
    label: vm.$t('entities.company'),
  },
  {
    key: 'regionalName',
    label: vm.$t('entities.regional'),
  },
  {
    key: 'installationName',
    label: vm.$t('entities.installation'),
  },
  {
    key: 'assetName',
    label: vm.$t('entities.asset'),
  },
];
